import styled from "styled-components";
import colors from "../../../../css/colors";
import { QuestionCircleOutlined } from "@ant-design/icons";

export const SectionCard = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  background-color: ${colors.WHITE};
  border: 1px solid ${colors.GREY_LIGHT};
  border-radius: 4px;
  padding: 0;
  max-width: 100%;

  @media screen and (max-width: 425px) {
    flex-direction: column;
  }
`;

interface SectionProps {
  flex?: number;
}

export const Section = styled.div<SectionProps>`
  display: flex;
  flex: ${(props) => (props.flex ? props.flex : "initial")};
  padding: 24px;
`;

export const LineBreak = styled.div`
  border: 0.5px solid ${colors.GREY_LIGHT};
`;

interface RowProps {
  margin?: string;
}

export const Row = styled.div<RowProps>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  &:not(:last-child) {
    margin: ${(props) => (props.margin ? props.margin : 0)};
  }

  textarea {
    resize: none;
  }

  .ant-input-number {
    width: 132px;
  }
`;

export const LinkWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const HSCodeLookupLink = styled.a``;

export const CostInputColumn = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  &:not(:last-child) {
    margin: 0 24px 0 0;
  }
`;

export const QuestionMark = styled(QuestionCircleOutlined)`
  margin-left: 5px;
`;
